// extracted by mini-css-extract-plugin
export default {"wrapper":"Transactions_wrapper__s9g3-","buttonsGroup":"Transactions_buttonsGroup__1w7hx","table":"Transactions_table__p4A9p"};